/**
 * PERSONALISATION BOX — Storefront JavaScript
 * FORCE INJECTS the property into AJAX requests to bypass custom themes
 */
(function () {
  'use strict';

  var wrapper    = document.querySelector('[data-personalisation-wrapper]');
  if (!wrapper) return; 

  var input      = wrapper.querySelector('[data-personalisation-input]');
  var charCount  = wrapper.querySelector('[data-char-count]');
  var charCounter= wrapper.querySelector('[data-char-counter]');
  var error      = wrapper.querySelector('[data-personalisation-error]');
  var toast      = document.querySelector('[data-personalisation-toast]');
  var toastClose = toast ? toast.querySelector('[data-toast-close]') : null;
  var toastProg  = toast ? toast.querySelector('[data-toast-progress]') : null;
  var maxLen     = parseInt(input.getAttribute('maxlength'), 10) || 50;
  var toastTimer = null;

  var productForm = findProductForm();
  if (productForm) {
    if (!productForm.id) {
      productForm.id = 'pform-' + Math.random().toString(36).substr(2, 9);
    }
    input.setAttribute('form', productForm.id);
  }

  // ── Character Counter ──
  input.addEventListener('input', function () {
    var len = this.value.length;
    if (charCount) charCount.textContent = len;
    if (charCounter) {
      if (len >= maxLen) {
        charCounter.classList.add('limit');
        charCounter.classList.remove('warning');
      } else if (len >= maxLen - 5) {
        charCounter.classList.add('warning');
        charCounter.classList.remove('limit');
      } else {
        charCounter.classList.remove('warning', 'limit');
      }
    }
    if (this.value.trim()) hideError();
  });

  // ── Validation ──
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      if (!input.value.trim()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showError();
        input.focus();
        return false;
      }
    }, true);
  }

  // ═══════════════════════════════════════════
  // ── FORCE AJAX INJECTION (THE FIX) ──
  // ═══════════════════════════════════════════
  
  // 1. Intercept Fetch API
  var _origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var options = arguments[1];
    var urlStr = (typeof url === 'string') ? url : (url && url.url ? url.url : '');

    if (urlStr.indexOf('/cart/add') !== -1 && options && options.body) {
      var pText = input ? input.value.trim() : '';
      if (pText) {
        try {
          if (options.body instanceof FormData) {
            options.body.append('properties[Personalisation]', pText);
          } else if (typeof options.body === 'string' && options.body.charAt(0) === '{') {
            var bodyData = JSON.parse(options.body);
            if (bodyData.items && bodyData.items.length > 0) {
              bodyData.items[0].properties = bodyData.items[0].properties || {};
              bodyData.items[0].properties['Personalisation'] = pText;
            } else {
              bodyData.properties = bodyData.properties || {};
              bodyData.properties['Personalisation'] = pText;
            }
            options.body = JSON.stringify(bodyData);
          }
        } catch (e) { console.warn('Personalisation intercept error:', e); }
      }
    }
    
    return _origFetch.apply(this, arguments).then(function (response) {
      if (response.ok && urlStr.indexOf('/cart/add') !== -1 && input && input.value.trim()) {
        showToast(input.value.trim());
      }
      return response;
    });
  };

  // 2. Intercept XMLHttpRequest (XHR)
  var _origOpen = XMLHttpRequest.prototype.open;
  var _origSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function () {
    this._pURL = arguments[1] || '';
    return _origOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    if (typeof this._pURL === 'string' && this._pURL.indexOf('/cart/add') !== -1) {
      var pText = input ? input.value.trim() : '';
      if (pText) {
        if (body instanceof FormData) {
          body.append('properties[Personalisation]', pText);
        } else if (typeof body === 'string') {
          if (body.charAt(0) === '{') {
            try {
              var bodyData = JSON.parse(body);
              if (bodyData.items && bodyData.items.length > 0) {
                bodyData.items[0].properties = bodyData.items[0].properties || {};
                bodyData.items[0].properties['Personalisation'] = pText;
              } else {
                bodyData.properties = bodyData.properties || {};
                bodyData.properties['Personalisation'] = pText;
              }
              body = JSON.stringify(bodyData);
            } catch(e) {}
          } else {
            body += '&properties[Personalisation]=' + encodeURIComponent(pText);
          }
        }
        
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) {
            showToast(pText);
          }
        });
      }
    }
    return _origSend.call(this, body);
  };

  if (toastClose) toastClose.addEventListener('click', hideToast);

  function findProductForm() {
    return document.querySelector('form[action*="/cart/add"]') ||
           document.querySelector('product-form form') ||
           document.querySelector('.product-form form') ||
           document.querySelector('[data-product-form] form') ||
           document.querySelector('.shopify-product-form');
  }

  function showError() {
    if (error) error.classList.add('visible');
    input.classList.add('has-error');
    wrapper.classList.add('shake');
    setTimeout(function () { wrapper.classList.remove('shake'); }, 600);
  }

  function hideError() {
    if (error) error.classList.remove('visible');
    input.classList.remove('has-error');
  }

  function showToast(text) {
    if (!toast) return;
    var span = toast.querySelector('[data-toast-personalisation]');
    if (span) span.textContent = '\u201C' + text + '\u201D';
    if (toastProg) {
      toastProg.style.animation = 'none';
      void toastProg.offsetHeight;
      toastProg.style.animation = '';
    }
    toast.classList.add('visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 4500);
  }

  function hideToast() {
    if (!toast) return;
    toast.classList.remove('visible');
    clearTimeout(toastTimer);
  }
})();